  (function () {
    const section = document.querySelector('.bi-directional-slider-section');
    if (!section) return;

    const track = section.querySelector('[data-slider-track]');
    const slides = section.querySelectorAll('.slider-slide');
    const titles = section.querySelectorAll('.slider-title');
    const dots = section.querySelectorAll('.pagination-dot');
    const prevBtn = section.querySelector('[data-nav="prev"]');
    const nextBtn = section.querySelector('[data-nav="next"]');

    const totalSlides = slides.length;
    let currentIndex = Math.floor(totalSlides / 2);

    function updateSlider(newIndex, direction = 'next') {
      if (newIndex < 0) newIndex = totalSlides - 1;
      if (newIndex >= totalSlides) newIndex = 0;

      // Update image slider (horizontal)
      track.style.transform = `translateX(-${newIndex * 100}%)`;

      // Update titles (vertical stack with dynamic positioning)
      titles.forEach((title, index) => {
        // Remove all existing state classes
        title.className = 'slider-title';
        
        if (index === newIndex) {
          // Active title
          title.classList.add('active');
        } else {
          // Calculate distance from active
          let distance = index - newIndex;
          
          // Handle wrap-around for circular behavior
          if (distance > totalSlides / 2) {
            distance -= totalSlides;
          } else if (distance < -totalSlides / 2) {
            distance += totalSlides;
          }
          
          // Apply appropriate position class based on distance
          if (distance < 0) {
            // Previous items (above active)
            title.classList.add('prev-' + Math.abs(distance));
          } else if (distance > 0) {
            // Next items (below active)
            title.classList.add('next-' + distance);
          }
        }
      });

      // Update pagination dots
      dots[currentIndex].classList.remove('active');
      dots[newIndex].classList.add('active');

      // Update slides active state
      slides[currentIndex].classList.remove('active');
      slides[newIndex].classList.add('active');

      currentIndex = newIndex;
    }

    // Initialize slider to show middle slide
    updateSlider(currentIndex);

    // Navigation buttons
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        updateSlider(currentIndex - 1, 'prev');
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        updateSlider(currentIndex + 1, 'next');
      });
    }

    // Pagination dots
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        if (index !== currentIndex) {
          updateSlider(index);
        }
      });
    });

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        updateSlider(currentIndex - 1, 'prev');
      } else if (e.key === 'ArrowRight') {
        updateSlider(currentIndex + 1, 'next');
      }
    });
    
    // Touch/Swipe support
    let touchStartX = 0;
    let touchEndX = 0;

    const wrapper = section.querySelector('[data-slider-wrapper]');

    if (wrapper) {
      wrapper.addEventListener(
        'touchstart',
        (e) => {
          touchStartX = e.changedTouches[0].screenX;
        },
        { passive: true }
      );

      wrapper.addEventListener(
        'touchend',
        (e) => {
          touchEndX = e.changedTouches[0].screenX;
          handleSwipe();
        },
        { passive: true }
      );
    }

    function handleSwipe() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          // Swipe left - next slide
          updateSlider(currentIndex + 1, 'next');
        } else {
          // Swipe right - previous slide
          updateSlider(currentIndex - 1, 'prev');
        }
      }
    }

    // Optional: Auto-play (uncomment to enable)
    /*
    let autoplayInterval;
    const autoplayDelay = 5000; // 5 seconds

    function startAutoplay() {
      autoplayInterval = setInterval(() => {
        updateSlider(currentIndex + 1, 'next');
      }, autoplayDelay);
    }

    function stopAutoplay() {
      clearInterval(autoplayInterval);
    }

    // Start autoplay
    startAutoplay();

    // Pause on hover
    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);
    */
  })();